import { ApolloClient, from, InMemoryCache, HttpLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { KeySpecifier } from '@apollo/client/cache/inmemory/policies'
import { isWeb } from 'tamagui'
import { router } from 'expo-router'
import * as Sentry from '@sentry/react-native'

const errorLink = onError(
  ({ graphQLErrors, operation, forward, networkError }) => {
    if (networkError) {
      console.error('GraphQL Network Error:', {
        message: networkError.message,
        operation: operation.operationName,
        variables: operation.variables,
        networkError,
      })

      Sentry.captureException(networkError, {
        tags: {
          type: 'graphql_network_error',
          operation: operation.operationName,
        },
        extra: {
          variables: JSON.stringify(operation.variables),
          message: networkError.message,
        },
      })
    }

    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        if (err.message === "Couldn't find User without an ID") {
          if (!isWeb) {
            router.replace('/users/sign_in')
          }
          return forward(operation)
        }
        if (err.message === 'Token is invalid') {
          return
        }
        if (err.extensions?.code) {
          switch (err.extensions.code) {
            case 'unauthorized':
            case 'empty_page':
              return forward(operation)
          }
        }
      }
    }
  },
)

const httpLink = new HttpLink({
  uri: process.env.EXPO_PUBLIC_GRAPHQL_URL,
})

const createFieldPolicy = (keyArgs: KeySpecifier) => ({
  keyArgs,
  merge(existing = { nodes: [] }, incoming: { nodes: [] }) {
    if (!incoming) return { ...existing, nodes: existing.nodes }
    return {
      ...incoming,
      nodes: [...existing.nodes, ...incoming.nodes],
    }
  },
})

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Course: {
        fields: {
          courseModules: createFieldPolicy(['id']),
        },
      },
    },
  }),
  link: from([errorLink, httpLink]),
})
